import type { ComponentChildren } from 'preact';
import { useState } from 'preact/hooks';

import { cx, Icon } from '@amumin/ui-core';

import { Dialog } from './Dialog.js';
import styles from './InfoButton.module.css';

export interface InfoButtonProps {
  /** Toegankelijke naam van de knop, bv. "Uitleg" (i18n `common.info`). */
  label: string;
  /** Titel van het blad; standaard het label. */
  title?: string | undefined;
  /** De uitleg zelf (alinea's, een lijst). */
  children: ComponentChildren;
  /** Naam van de sluitknop (i18n `design.dialog.close`). */
  closeLabel: string;
  name?: string | undefined;
  class?: string | undefined;
}

/**
 * (i)-knop: uitleg die niet altijd open hoeft te staan, in een blad (docs/ux/ontwerpsysteem.md,
 * regel U1). Niet gebruiken voor uitleg bij een toestemming (geloof, gezondheid, bank): die blijft
 * open staan op het moment dat iemand toestemming geeft (AVG art. 9).
 */
export function InfoButton({
  label,
  title,
  children,
  closeLabel,
  name = 'info',
  class: cls,
}: InfoButtonProps) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        class={cx(styles.info, cls)}
        aria-label={label}
        title={label}
        aria-haspopup="dialog"
        aria-expanded={open ? 'true' : 'false'}
        data-name={name}
        onClick={() => setOpen(true)}
      >
        <Icon id="info" size={20} />
      </button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        title={title ?? label}
        variant="sheet"
        closeLabel={closeLabel}
        name={`${name}-sheet`}
        expandable={false}
      >
        <div class={styles.body}>{children}</div>
      </Dialog>
    </>
  );
}
